import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import { useEffect } from 'react';
import { classnames } from 'tailwindcss-classnames';

/**
 * Not sure why it's an img src, but that's what Sitecore uses in Experience Editor, so mimic that.
 */
const scKeepAlive = () => {
  const img = document.getElementById('scKeepAlive') as HTMLImageElement;

  img.src = `/sitecore/service/keepalive.aspx?ts=${Math.round(Math.random() * 12361814)}`;
};

// 5 minutes
const keepAliveTimeout = 5 * 1000 * 60;

const SitecoreKeepAlive = (): JSX.Element => {
  const isExperienceEditor = useExperienceEditor();

  // Call on client-side
  useEffect(() => {
    // Only if Experience Editor
    if (isExperienceEditor) {
      const intervalId = setInterval(scKeepAlive, keepAliveTimeout);

      return () => clearInterval(intervalId); // This is important
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  });
  return isExperienceEditor ? (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      id="scKeepAlive"
      data-testid="keep-alive"
      width={1}
      height={1}
      alt=""
      className={classnames('absolute', 'hidden')}
    />
  ) : (
    <></>
  );
};

export default SitecoreKeepAlive;
